import { ResponsiveBar } from '@nivo/bar';
import { useColorModeValue } from '@chakra-ui/react';
import { padding } from 'variables/nivo/bar';
import { monochromeMainColors } from 'variables/colors';
import {
	axisLeft,
	themeDark,
	themeLight,
	tooltip
} from 'variables/nivo/default';

const buildData = (data) => {
	const values = [];

	if (!data) return values;

	values.push({
		id: 'nenhum',
		label: 'Nenhuma',
		value: data.nenhum
	});
	values.push({
		id: 'danca',
		label: 'Dança',
		value: data.danca
	});
	values.push({
		id: 'funcional',
		label: 'Funcional',
		value: data.funcional
	});
	values.push({
		id: 'esportes',
		label: 'Esportes',
		value: data.esportes
	});
	values.push({
		id: 'corrida',
		label: 'Corrida',
		value: data.corrida
	});
	values.push({
		id: 'caminhada',
		label: 'Caminhada',
		value: data.caminhada
	});
	values.push({
		id: 'academia',
		label: 'Academia/Ginástica',
		value: data.academia
	});

	return values;
};

const ActivitiesChart = ({ data }) => (
	<ResponsiveBar
		data={buildData(data)}
		keys={['value']}
		indexBy="label"
		layout="horizontal"
		margin={{ top: 5, right: 10, bottom: 5, left: 120 }}
		padding={padding}
		colors={monochromeMainColors}
		labelSkipWidth={11}
		theme={useColorModeValue(themeLight, themeDark)}
		axisBottom={null}
		axisLeft={axisLeft}
		labelTextColor="#FFF"
		tooltip={({ indexValue, value }) => tooltip(indexValue, value)}
	/>
);

export default ActivitiesChart;
